export interface Refund {
  id: number;
  authorized_by: number;
  created_at: string;
  reason: string;
  token: string;
  is_store_credit: boolean;
  purchased_payment_method_id: number;
  description: string;
  refunded?: number;
  credits_refunded?: number;
}

export interface Purchase {
  id: number;
  total: number;
  promo_discount: number;
  promo_id?: number;
  promo_description?: string;
  customer: Customer;
  store: Store;
  pre_discount_total: number;
  manual_discount: number;
  total_tax_applied: number;
  purchasedate: string;
  total_credits_used: number;
  line_items: LineItem[];
  payment_methods?: PaymentMethod[];
  total_refunded: number;
  refunds?: any[];
  subtotal: number;
  refund_version_available?: number;
  refund_unavailability_reason?: string;
  prior_refunds?: Refund[];
}
export interface Customer {
  id: number;
  first_name?: string;
  last_name?: string;
}
export interface Store {
  id: number;
  name: string;
  address: string;
  phone: string;
  email: string;
  store_code: string;
  tax_rate: number;
}
export interface LineItem {
  purchasable_item_id: number;
  description: string;
  list_price: number;
  manual_discount: number;
  pre_tax_total: number;
  final_amount: number;
  edit_amount?: number;
  credits_used: number;
  credit_description: string;
  is_ingredient: boolean;
  id: string;
  refunded?: boolean;
  bundle_count: number;
  unused_bundle_count?: number;
  count_to_refund?: number;
  selected?: boolean;
  refund_amount: number;
  unavailable_for_refund?: boolean;
  unavailable_reason?: string;
  is_medical?: boolean;
  service_administered?: boolean;
}

export interface PaymentMethod {
  id: number;
  description: string;
  amount: number;
  refunded?: number;
  token?: string;
  is_cash?: boolean | null;
  gift_card?: number;
  third_party_coupon?: number;
}

export type PaymentMethods = Array<PaymentMethod>;

export enum TenderTypes {
  CASH_PM = 'cash',
  CARD_PM = 'card',
  CREDIT_PM = 'credit',
  ACCOUNT_BAL_PM = 'account balance',
  THIRD_PARTY_COUPON = '3rd party coupon',
  GIFT_CARD = 'gift card'
}

export type Credit = {
  id: string;
  count: number;
  name: string;
  purchasableItemId: number;
};

export type Refundable = {
  id?: string | number;
  amountToRefund?: number;
  refundToCredit?: number;
  credits?: Credit[];
  availableToRefund?: number;
  description: string;
  totalPurchased?: number;
  type: TenderTypes;
  third_party_coupon?: number;
};

export type RefundReason = {
  id: string;
  value: string;
  display: string;
};
